import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Card, CardStyle } from '../components/Card';
import { Page } from '../components/Page';
import PublicGuideCard from '../components/PublicGuideCard';
import { CardList } from '../components/CardList';
import PublicFooter from '../components/PublicFooter';

const makeURL = (name: string) => `/static-${name}`;

export type HomeProps = RouteComponentProps<any>;

export default class Home extends React.Component<HomeProps, any> {
  render() {
    return (
      <Page
        title="Filtru Brew Guides"
        subtitle="Get better at making specialty coffee with our step-by-step brew guides"
      >
        <div className="w-100 sans-serif">
          <article className="bg-white black mw9 ml-auto mr-auto">
            <CardList className="animated fadeIn">
              <PublicGuideCard
                name="Chemex"
                owner="Filtru Coffee"
                method="Chemex"
                url={makeURL('chemex')}
                grind_size="Medium"
                coffee="25g"
                water="340ml"
              />
              <PublicGuideCard
                name="AeroPress"
                owner="Filtru Coffee"
                method="AeroPress"
                url={makeURL('aeropress')}
                grind_size="Fine"
                coffee="15g"
                water="240ml"
              />
              <PublicGuideCard
                name="Hario V60"
                owner="Filtru Coffee"
                method="Hario V60"
                url={makeURL('hariov60')}
                grind_size="Medium"
                coffee="13g"
                water="220ml"
              />

              <PublicGuideCard
                name="Bonmac"
                owner="Filtru Coffee"
                method="Bonmac"
                url={makeURL('bonmac')}
                grind_size="Medium"
                coffee="15g"
                water="250ml"
              />
              <PublicGuideCard
                name="Bee House Dripper"
                owner="Filtru Coffee"
                method="Beehouse"
                url={makeURL('beehouse')}
                grind_size="Medium"
                coffee="15g"
                water="250ml"
              />
              <PublicGuideCard
                name="Kalita Wave"
                owner="Filtru Coffee"
                method="Kalita Wave"
                url={makeURL('kalita')}
                grind_size="Medium"
                coffee="15g"
                water="250ml"
              />

              <PublicGuideCard
                name="Moka Pot"
                owner="Filtru Coffee"
                method="Moka Pot"
                url={makeURL('mokapot')}
                grind_size="Extra Fine"
                coffee="18g"
                water="200ml"
              />
              <PublicGuideCard
                name="French Press"
                owner="Filtru Coffee"
                method="French Press"
                url={makeURL('frenchpress')}
                grind_size="Coarse"
                coffee="30g"
                water="350ml"
              />
              <PublicGuideCard
                name="Siphon"
                owner="Filtru Coffee"
                method="Siphon"
                url={makeURL('siphon')}
                grind_size="Fine"
                coffee="20g"
                water="300ml"
              />
            </CardList>
          </article>
        </div>
        <PublicFooter />
      </Page>
    );
  }
}
